import { ComponentType } from 'react';
import { UserSearch } from '../views/UserSearch';
import { Login } from '../views/Login';
import { UserDetail } from '../views/UserDetail';
import { CUSSUP_ROLES } from '../types/auth';
import { CreateIdentity } from '../views/CreateIdentity';
import { SubscriptionDetail } from '../views/SubscriptionDetail';
import { SubscriptionSearch } from '../views/SubscriptionSearch';

export enum ROUTES {
  ROOT = '/',
  SEARCH = 'user/search',
  DETAIL = 'user/detail/:identityId',
  IDENTITIES = '/identities',
  SUBSCRIPTION_SEARCH = 'subscription/search',
  SUBSCRIPTION_DETAIL = '/subscriptions/:system/:subscriptionId',
}

interface GuardedRoute {
  path: string;
  Component: ComponentType;

  requiredRoles: CUSSUP_ROLES[];
  props?: Record<string, unknown>;
}

export const Routes: GuardedRoute[] = [
  {
    path: ROUTES.ROOT,
    Component: Login,
    requiredRoles: [],
  },
  {
    path: ROUTES.SEARCH,
    Component: UserSearch,
    requiredRoles: [
      CUSSUP_ROLES.CUSSUP_GENERAL,
      CUSSUP_ROLES.CUSSUP_SPECIALIZED,
      CUSSUP_ROLES.CUSSUP_DATA_PROTECTION,
    ],
  },
  {
    path: ROUTES.DETAIL,
    Component: UserDetail,
    requiredRoles: [
      CUSSUP_ROLES.CUSSUP_GENERAL,
      CUSSUP_ROLES.CUSSUP_SPECIALIZED,
      CUSSUP_ROLES.CUSSUP_DATA_PROTECTION,
    ],
  },
  {
    path: ROUTES.IDENTITIES,
    Component: CreateIdentity,
    requiredRoles: [
      CUSSUP_ROLES.CUSSUP_GENERAL,
      CUSSUP_ROLES.CUSSUP_SPECIALIZED,
      CUSSUP_ROLES.CUSSUP_DATA_PROTECTION,
    ],
  },
  {
    path: ROUTES.SUBSCRIPTION_SEARCH,
    Component: SubscriptionSearch,
    requiredRoles: [
      CUSSUP_ROLES.CUSSUP_GENERAL,
      CUSSUP_ROLES.CUSSUP_SPECIALIZED,
      CUSSUP_ROLES.CUSSUP_DATA_PROTECTION,
    ],
  },
  {
    path: ROUTES.SUBSCRIPTION_DETAIL,
    Component: SubscriptionDetail,
    requiredRoles: [
      CUSSUP_ROLES.CUSSUP_GENERAL,
      CUSSUP_ROLES.CUSSUP_SPECIALIZED,
      CUSSUP_ROLES.CUSSUP_DATA_PROTECTION,
    ],
  },
];
